<template>
  <a class="skip-to-content" href="#main">Skip to content</a>
</template>
<script setup lang="ts"></script>
